import React,{lazy, Suspense} from "react";

import { Routes, Route } from "react-router-dom";
import MessageLoader from "./assets/MessageLoader"
import MobileNavbar from "./components/MobileNavbar";
import Navbar from "./components/Navbar";
import MainLoader from "./assets/Mainloader/MainLoader";

import ActionUser from "./components/ActionUsers/ActionUser";
import { ChatState } from "./assets/context";
const Home = lazy(() => import("./pages/Home"))
const Login = lazy(() => import("./pages/Login"))
const Signup = lazy(() => import("./pages/Signup"))
const Profile = lazy(() => import("./components/Profile/Profile"))
const Chattingpage = lazy(() => import("./components/Chattingpage"))
const Message = lazy(() => import("./components/message"))
function App() {
  const { ActionMembers } = ChatState();
  return (
    <>
      <MainLoader />

      <Navbar />
      <MobileNavbar />
      {ActionMembers.type === true ? <ActionUser /> : ""}
      <Suspense fallback={<MessageLoader/>}>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/message" element={<Message />}>
          <Route path="/message/chat" element={<Chattingpage />} />
        </Route>
      </Routes>
      </Suspense>
    </>
  );
}

export default App;
